import Message from '@/constant/message';
import fetcher from '@/utils/fetcher';

interface PostCheckConfirmCodeProps {
  type: 'email' | 'social' | 'pwreset';
  email: string;
  code: string;
}
/** 이메일 인증코드 일치 확인 */
const postCheckConfirmCode = async ({ type, email, code }: PostCheckConfirmCodeProps) => {
  try {
    const res = await fetcher.post(`/api/auth/verify/${type}/check`, {
      data: { email, code },
    });
    return {
      data: {
        isAgreed: res.data.data as boolean,
      },
    };
  } catch (e: any) {
    const message = e.response?.data?.error?.message;
    if (message === 'many of count of failure') return { error: Message.인증코드입력5회이상실패했습니다다시시도해주세요 };
    if (message === 'wrong code') return { error: Message.인증코드가일치하지않습니다다시시도해주세요 };
    return { error: Message.처리도중서버에서오류가발생했습니다잠시후다시시도하시거나관리자에게문의해주세요 };
  }
};

export default postCheckConfirmCode;
